import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/slices/authSlice";
import { resetUser } from "../../redux/slices/userSlice";
import { userService } from "../../services/userService";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";

const InfSidebar = (props) => {
  const { userInfo } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  let roleName = "Unknown";
  if (user) {
    try {
      const decoded = jwtDecode(user);
      roleName =
        decoded[
          "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
        ] || "Unknown";
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  }

  const handleLogout = async () => {
    const response = await userService.logout();
    if (response && response.data.message) {
      dispatch(logout());
      dispatch(resetUser());
      toast.success(response.data.message);
      queueMicrotask(() => navigate("/"));
    } else {
      toast.error("Đăng xuất không thành công, vui lòng thử lại sau!");
    }
  };

  return (
    <div className="col-xl-3 col-lg-4 theiaStickySidebar">
      <div className="card user-sidebar mb-4 mb-lg-0">
        <div className="card-header user-sidebar-header">
          <div className="profile-content rounded-pill">
            <div className="d-flex align-items-center justify-content-between">
              <div className=" d-flex align-items-center justify-content-center">
                <img
                  src={userInfo && userInfo.imageUrl ? userInfo.imageUrl : ""}
                  alt="img"
                  className="img-fluid avatar avatar-lg rounded-circle flex-shrink-0 me-1"
                />
                <div>
                  <h6 className="fs-16">
                    {userInfo && userInfo.fullName ? userInfo.fullName : ""}
                  </h6>
                  <span className="fs-14 text-gray-6">
                    Vai trò:{" "}
                    {roleName === "Staff"
                      ? "Nhân viên"
                      : roleName === "Customer"
                      ? "Khách hàng"
                      : roleName === "Admin"
                      ? "Quản trị viên"
                      : "Hướng dẫn viên"}
                  </span>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center justify-content-center">
                  <a
                    href="profile-settings.html"
                    className="p-1 rounded-circle btn btn-light d-flex align-items-center justify-content-center"
                  >
                    <i className="isax isax-edit-2 fs-14"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body user-sidebar-body">
          <ul>
            <li>
              <span className="fs-14 text-gray-3 fw-medium mb-2">Main</span>
            </li>
            {/* <li>
              <a href="dashboard.html" className="d-flex align-items-center">
                <i className="isax isax-grid-55"></i> Dashboard
              </a>
            </li> */}
            <li className="submenu">
              <Link
                // href="#"
                // class={isOpen ? "d-block active subdrop" : "d-block active"}
                to="/customer-tour-booking"
                className={`${
                  props.page === "customer-tour-booking" ? "active" : ""
                }`}
              >
                <i className="isax isax-calendar-tick5"></i>
                <span>Tour</span>
                {/* <span className="menu-arrow" onClick={toggleDropdown}></span> */}
              </Link>
              {/* <ul style={{ display: isOpen ? "block" : "none" }}>
                <li>
                  <a
                    href="customer-flight-booking.html"
                    className="fs-14 d-inline-flex align-items-center"
                  >
                    Flights
                  </a>
                </li>
                <li>
                  <a
                    href="customer-hotel-booking.html"
                    className="fs-14 d-inline-flex align-items-center"
                  >
                    Hotels
                  </a>
                </li>
                <li>
                  <a
                    href="customer-car-booking.html"
                    className="fs-14 d-inline-flex align-items-center"
                  >
                    Cars
                  </a>
                </li>
                <li>
                  <a
                    href="customer-cruise-booking.html"
                    className="fs-14 d-inline-flex align-items-center"
                  >
                    Cruise
                  </a>
                </li>
                <li>
                  <span
                    style={{
                      color: "#4E5561",
                      padding: "8px",
                      fontSize: "14px",
                      fontWeight: 500,
                      cursor: "pointer",
                    }}
                    className="fs-14 d-inline-flex align-items-center"
                    onClick={() => handleNavigation("/customer-tour-booking")}
                  >
                    Tour
                  </span>
                </li>
              </ul> */}
            </li>
            {/* <li>
              <Link
                to={"/review"}
                className={`d-flex align-items-center ${
                  props.page === "review" ? "active" : ""
                }`}
              >
                <i className="isax isax-magic-star5"></i> My Reviews
              </Link>
            </li> */}
            <li>
              <div className="message-content">
                <Link to={"/chat"} className="d-flex align-items-center">
                  <i className="isax isax-message-square5"></i> Messages
                </Link>
                {/* <span className="msg-count rounded-circle">02</span> */}
              </div>
            </li>
            <li className="mb-2">
              <Link
                to={"/wishlist"}
                className={`d-flex align-items-center ${
                  props.page === "wishlist" ? "active" : ""
                }`}
              >
                <i className="isax isax-heart5"></i> Wishlist
              </Link>
            </li>

            {roleName && (roleName === "Staff" || roleName === "Tour guide") ? (
              <>
                <li>
                  <span className="fs-14 text-gray-3 fw-medium mb-2">
                    Nhiệm vụ
                  </span>
                </li>
                {roleName && roleName === "Staff" ? (
                  <li className="mb-2">
                    <Link
                      to={"/tour-assign"}
                      className={`d-flex align-items-center ${
                        props.page === "tour-assign" ? "active" : ""
                      }`}
                    >
                      <i class="fa-solid fa-paper-plane"></i> Tour chưa assign
                    </Link>

                    <Link
                      to={"/tour-booking-cancel"}
                      className={`d-flex align-items-center ${
                        props.page === "cancel-pending-bookings" ? "active" : ""
                      }`}
                    >
                      <i class="fa-solid fa-plane-slash"></i> Tour yêu cầu hủy
                    </Link>
                  </li>
                ) : (
                  <li className="mb-2">
                    <Link
                      to={"/tour-guide-assign"}
                      className={`d-flex align-items-center ${
                        props.page === "tour-guide-assignments" ? "active" : ""
                      }`}
                    >
                      <i class="fa-solid fa-paper-plane"></i> Tour sắp diễn ra
                    </Link>
                  </li>
                )}
              </>
            ) : (
              ""
            )}
            {/* <li>
              <span className="fs-14 text-gray-3 fw-medium mb-2">Finance</span>
            </li>
            <li>
              <a href="wallet.html" className="d-flex align-items-center">
                <i className="isax isax-wallet-add-15"></i> Wallet
              </a>
            </li>
            <li className="mb-2">
              <a href="payment.html" className="d-flex align-items-center">
                <i className="isax isax-money-recive5"></i> Payments
              </a>
            </li> */}
            <li>
              <span className="fs-14 text-gray-3 fw-medium mb-2">Account</span>
            </li>
            <li>
              <Link
                to={"/my-profile"}
                className={`d-flex align-items-center ${
                  props.page === "my-profile" ? "active" : ""
                }`}
              >
                <i className="isax isax-profile-tick5"></i> Thông tin cá nhân
              </Link>
            </li>
            {/* <li>
              <div className="message-content">
                <a
                  href="notification.html"
                  className="d-flex align-items-center"
                >
                  <i className="isax isax-notification-bing5"></i> Notifications
                </a>
                <span className="msg-count bg-purple rounded-circle">05</span>
              </div>
            </li> */}
            {/* <li>
              <Link
                href="profile-settings.html"
                className={`d-flex align-items-center  ${
                  props.page === "setting" ? "active" : ""
                }`}
              >
                <i className="isax isax-setting-25"></i> Thiết lập
              </Link>
            </li> */}
            <li>
              <Link
                to="/"
                className="d-flex align-items-center pb-0"
                onClick={handleLogout}
              >
                <i className="isax isax-logout-15"></i> Đăng xuất
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default InfSidebar;
